import Icon from '@/components/atoms/Icon';
import { MediaEmptyStateProps } from '@/Pages/BrandKit/types';

export default function MediaEmptyState({
  icon,
  title,
  description,
  ctaLabel,
  ctaHref
}: MediaEmptyStateProps): JSX.Element {
  return (
    <div className="flex w-full justify-center">
      <div className="flex w-[448px] flex-col items-center gap-4 py-5">
        <div className="flex items-center justify-center text-slate-500">
          <Icon name={icon} size={24} stroke={1.5} />
        </div>
        <div className="text-center">
          <p className="text-sm font-semibold text-slate-500">{title}</p>
          <p className="mt-2 text-sm text-slate-500">{description}</p>
        </div>
        <button
          type="button"
          data-testid="media-empty-state-cta"
          onClick={() => window.open(ctaHref, '_blank')}
          className="flex items-center gap-0.5 rounded-md border border-slate-200 bg-white px-1 py-0.5 text-sm text-black hover:bg-slate-50"
        >
          <Icon name="IconPlus" size={16} stroke={2} />
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}
